import React from "react";
import Button from "@mui/material/Button";
import "./Experience.css";
import { Fade } from "react-awesome-reveal";
import Highlighter from "react-highlight-words";
export default function ProjectItem({
  firstProject,
  projectName,
  projectContent,
  projectHref,
  projectImage,
}) {
  return (
    <div className="experience">
      <Fade direction="down" duration="2000" triggerOnce>
        <h1
          style={{
            textAlign: "center",
            fontWeight: "400",
          }}
        >
          Experience
        </h1>
      </Fade>

      <main>
        <div className="experienceInfo">
          <Fade direction="left" duration="2000" triggerOnce>
            <h2 style={{ color: "green" }}>Full stack intern</h2>
            <p
              style={{
                color: "grey",
                fontSize: "smaller",
                marginTop: "-0.2rem",
              }}
            >
              NordInsight{" "}
            </p>
            <p style={{ lineHeight: ".25rem" }}>
              <ul>
                <li>
                  -Developed new features for the admin system using React and
                  TypeScript for the frontend, and created relevant RESTful APIs
                  and utilized MongoDB for the backend
                </li>
                <li>
                  -Designed and implemented the light mode for the system,
                  improving user experience and accessibility
                </li>
                <li>
                  -Collaborated with the development team to identify and fix
                  bugs, helping the product launched on time with high quality
                </li>
              </ul>
            </p>
            <Button
              variant="contained"
              color="success"
              style={{ fontSize: ".12rem", width: "1rem" }}
            >
              <a
                href="https://nordinsight.com/"
                target="_blank"
                style={{ color: "white" }}
              >
                More Info
              </a>
            </Button>
          </Fade>
        </div>
        <div className="experienceComment">
          <Fade direction="right" duration="2000" triggerOnce>
            <div className="comment">
              <div className="commentImg">
                <img src="../../assets/simon.jpeg" />
              </div>
              <p>
                Sixun made significant contributions to our design and
                development of our software, proving herself to be an invaluable
                team player. Even when confronted with complex tasks, she
                displayed exceptional problem-solving skills and a genuine
                passion for learning and growth.
              </p>
              <hr
                style={{
                  backgroundColor: "#e1e1e1",
                  height: "1px",
                  border: "none",
                }}
              />
              <h3>Simon Elliott Thomassen</h3>
              <p style={{ color: "grey", fontSize: ".15rem" }}>
                Co-founder & CEO hos NordInsight
              </p>
            </div>
          </Fade>
        </div>
      </main>
    </div>
  );
}
